/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/*
 * StaffBanner.jsx
 * Created by Destin Frasier on 12/11/20
 */

import React from 'react';
import { BrandingIcon } from 'sarsaparilla';

export default function StaffBanner() {
    return (
        <div className="ugc-story-staff-banner">
            <span className="ugc-story-staff-icon">
                <BrandingIcon iconName="compass" />
            </span>
            Staff Story
        </div>
    );
}
